/*
  "Rask savo porą" - buy quiz (sections/rask-pora.liquid).

  A small state machine: questions -> loader -> result. Copy, products and
  prices arrive in the JSON block the section prints; nothing here is typed in
  by hand. Progress is kept in localStorage so a refresh never restarts the
  quiz, and the product page reads the same key to offer "continue".
*/
(() => {
  'use strict';

  const root = document.querySelector('[data-rp]');
  if (!root) return;
  let C;
  try { C = JSON.parse(root.querySelector('[data-rp-config]').textContent); } catch (e) { return; }

  const T = C.copy;
  // Display name of a colour value (PL copy maps Juoda -> Czarny ...); LT shows the value itself.
  const cName = (c) => ((T.colourName || {})[c]) || c;
  const Q = C.q;
  // Men: black and grey only, one new size (43–48) plus whatever old size is left.
  if (C.products && C.products.m) {
    const M = C.products.m;
    // Men: the wide-calf size (all colours) and XL (black, grey leftover).
    const MEN_SIZES = ['Pėda 40–42', 'Pėda 43–48', 'Pėda 35–42 · L (blauzda 34–48 cm)', 'Pėda 42–46 · XL (blauzda 40–52 cm)'];
    M.sizes = (M.sizes || []).filter((x) => MEN_SIZES.includes(x));
    M.variants = (M.variants || []).filter((v) => MEN_SIZES.includes(v.s));
    M.colours = (M.colours || []).filter((c) => M.variants.some((v) => v.c === c));
  }
  const KEY = 'svelna_rask_pora_v3';
  // Opened from a gift page: the first answer is already "a gift", and the result links to the set.
  const GIFT_MODE = /[?&]dovana=1/.test(location.search);
  const WEEK = 7 * 24 * 60 * 60 * 1000;

  const stage = root.querySelector('[data-rp-stage]');
  const barEl = root.querySelector('[data-rp-bar]');
  const countEl = root.querySelector('[data-rp-count]');
  const backBtn = root.querySelector('[data-rp-back]');

  /* ---------- state ---------- */

  const fresh = () => ({ a: {}, cur: 'q0', hist: [], t0: Date.now(), secs: 0, done: false, tier: -1, colour: '', size: '', bag: false, msg: '' });
  let st = fresh();

  const load = () => {
    try {
      const s = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!s || typeof s !== 'object' || !s.a || typeof s.a !== 'object' || !Array.isArray(s.hist) || typeof s.cur !== 'string') return null;
      if (Date.now() - (s.ts || 0) > WEEK) return null;
      if (!Q[s.cur] && s.cur !== 'result') return null;
      return Object.assign(fresh(), s);
    } catch (e) { return null; }
  };
  const save = () => {
    try { localStorage.setItem(KEY, JSON.stringify(Object.assign({}, st, { ts: Date.now() }))); } catch (e) {}
  };

  /* ---------- helpers ---------- */

  const esc = (x) => String(x == null ? '' : x).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));

  // A product that is unpublished or has no variants cannot be offered at all.
  const sellable = (k) => !!(C.products[k] && C.products[k].variants && C.products[k].variants.length);
  const GENDERS = ['w', 'm'].filter(sellable);

  const isGift = () => !!st.a.q0 && st.a.q0.indexOf('sau') !== 0;
  const gender = () => {
    const g = st.a.q0 === 'sau-w' ? 'w' : st.a.q0 === 'sau-m' ? 'm' : (st.a.q1 || 'w');
    return sellable(g) ? g : GENDERS[0];
  };
  const voice = () => (!isGift() ? 'sau' : (gender() === 'm' ? 'jam' : 'jai'));
  // A string, or one string per voice (yourself / her / him).
  // PL adds "sauM" for a man answering for himself (Pan instead of Pani); LT has no such key.
  const tx = (x) => ((x && typeof x === 'object') ? ((voice() === 'sau' && gender() === 'm' && x.sauM) || x[voice()] || x.sau || '') : (x || ''));

  const money = (cents) => {
    const n = (cents / 100).toFixed(2);
    const f = (C.currency === 'PLN' ? '{{amount_with_comma_separator}} zł' : C.money) || '€{{amount_with_comma_separator}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => (k.indexOf('comma') > -1 ? n.replace('.', ',') : n)).replace(/<[^>]*>/g, '');
  };

  const pairs = (n) => {
    const d = n % 10;
    const h = n % 100;
    if (T.plural) return n + ' ' + (n === 1 ? T.plural[0] : (d >= 2 && d <= 4 && !(h >= 12 && h <= 14)) ? T.plural[1] : T.plural[2]);
    if (d === 1 && h !== 11) return n + ' pora';
    if (d === 0 || (h >= 11 && h <= 19)) return n + ' porų';
    return n + ' poros';
  };

  const track = (ev, data) => {
    const name = 'rask_pora_' + ev;
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, data || {}); } catch (e) {}
    // Clarity is the one tool that runs in the page itself, so the funnel can be read there.
    try { if (window.clarity) window.clarity('event', name + (data && data.step ? '_' + data.step : '')); } catch (e) {}
  };
  // Custom Meta events only: Shopify's own pixel already reports the product view and the checkout start.
  const pixel = (ev, data) => { try { if (window.fbq) window.fbq('trackCustom', ev, data); } catch (e) {} };

  /* ---------- flow ---------- */

  // Kept for saved states from the first days, when "Jau Švelna" was an answer.
  const returning = () => st.a.q4 === 'svelna';

  const nextOf = (id) => {
    switch (id) {
      case 'q0': return isGift() && GENDERS.length > 1 ? 'q1' : 'qa';
      case 'q1': return 'qa';
      case 'qa': return 'q2';
      // 43–46 is XL on its own; 35–42 asks about the calf. The "what do you wear now" step is gone.
      // men have one calf width per size, so the calf question is for women only
      case 'q2': return (st.a.q2 === '1' || gender() === 'm') ? 'q5' : 'q3';
      case 'q3': return 'q5';
      // Already wears Švelna: colour only, then the result with the biggest set.
      case 'q4': return returning() ? 'q7' : 'q5';
      case 'q5': return 'q7';
      case 'q6': return 'q7';
      case 'q7': return GIFT_MODE ? 'giftgo' : (returning() ? 'result' : 'q8');
      case 'q8': return 'result';
      default: return 'result';
    }
  };

  const path = () => {
    const p = [];
    let id = 'q0';
    while (id !== 'result' && id !== 'giftgo' && p.length < 12) { p.push(id); id = nextOf(id); }
    return p;
  };

  /* ---------- product maths ---------- */

  const product = () => C.products[gender()];

  // The four foot-size answers map to the new sizes. While a product still sells only
  // the old two-size variants, the answer takes the old size that covers that foot.
  const NEW_SIZES = ['Pėda 34–36', 'Pėda 37–39', 'Pėda 40–42', 'Pėda 43–48', 'Pėda 35–42 · S (blauzda 28–39 cm)', 'Pėda 35–42 · M (blauzda 31–44 cm)', 'Pėda 35–42 · L (blauzda 34–48 cm)', 'Pėda 42–46 · XL (blauzda 40–52 cm)'];
  const NEW_TOP = [36, 39, 42, 48];
  const isNewSize = (s) => /^Pėda/.test(s || '');
  const sizeLabel = (s) => ((product().sizeLabels || {})[s]) || s;
  const CALF_IDX = { siaura: 0, vidutine: 1, didele: 2 };
  const sizeFromAnswer = () => {
    const P = product();
    const foot = parseInt(st.a.q2, 10) || 0;
    if (gender() === 'm') return foot === 1 ? 'Pėda 43–48' : 'Pėda 40–42';
    const calf = CALF_IDX[st.a.q3];
    const i = foot === 1 ? 3 : (calf === undefined ? 1 : calf);
    if (P.sizes.indexOf(NEW_SIZES[i]) > -1) return NEW_SIZES[i];
    const old = P.sizes.filter((s) => !isNewSize(s));
    return old.find((s) => parseInt(String(s).split('-')[1], 10) >= NEW_TOP[i]) || old[old.length - 1] || P.sizes[0];
  };

  const colourOrder = () => {
    const P = product();
    const known = T.colourOrder.filter((c) => P.colours.indexOf(c) > -1);
    return known.concat(P.colours.filter((c) => known.indexOf(c) < 0));
  };

  const colourFromAnswer = () => {
    const P = product();
    const a = st.a.q7;
    if (a && a !== 'any' && P.colours.indexOf(a) > -1) return a;
    const auto = T.autoColour[st.a.q5];
    if (auto && P.colours.indexOf(auto) > -1) return auto;
    return colourOrder()[0];
  };

  const findVariant = (c, s) => product().variants.find((v) => v.c === c && v.s === s);
  // The photo that stands for a colour: men get the masculine studio shot when there is one.
  const heroImg = (v) => ((gender() === 'm' && C.colourM && C.colourM[v.c]) || v.img);

  // The main photo of the chosen colour plus its five studio angles (assets/rask-gal-*). The product
  // page's other photos are not pulled in: they carry text and marketing layouts.
  const gallery = (v) => {
    const out = [heroImg(v)];
    const extra = (gender() === 'm' ? C.extraM : C.extra) || {};
    if (extra[v.c]) extra[v.c].forEach((src) => { if (out.indexOf(src) < 0) out.push(src); });
    return out;
  };

  // The pair to show. A sold-out colour falls to the next one in stock in the
  // same size; a size with nothing left is reported, never sold.
  const pick = () => {
    const size = st.size || sizeFromAnswer();
    // A colour the shopper named gets a note when it is sold out; one the quiz chose is swapped quietly.
    const named = st.colour || (st.a.q7 && st.a.q7 !== 'any' && product().colours.indexOf(st.a.q7) > -1 ? st.a.q7 : '');
    const wanted = named || colourFromAnswer();
    let v = findVariant(wanted, size);
    let note = '';
    let out = false;
    if (!v || !v.ok) {
      const alt = colourOrder().map((c) => findVariant(c, size)).find((x) => x && x.ok);
      if (alt) {
        if (named) note = T.swapNote.replace('{gen}', () => T.colourGen[wanted] || wanted).replace('{size}', () => sizeLabel(size)).replace('{acc}', () => T.colourAcc[alt.c] || alt.c.toLowerCase());
        v = alt;
      } else {
        out = true;
        v = v || product().variants.find((x) => x.s === size) || product().variants[0];
      }
    }
    return { v: v, size: size, note: note, out: out };
  };

  // Same sums as the product page: the variant carries the full price and the
  // sale percentage in Settings > Kainos mirrors the automatic discount.
  const unitNow = (v) => ((C.salePct > 0 && v.price > 0 && !v.cmp) ? Math.floor((v.price * (100 - C.salePct) + 50) / 100) : v.price);
  const unitWas = (v) => ((C.salePct > 0 && v.price > 0 && !v.cmp) ? v.price : (v.cmp || 0));
  const tierPrice = (v, t) => {
    const now = t.fixed ? t.fixed : unitNow(v) * t.paid;
    const was = t.total > t.paid ? unitNow(v) * t.total : unitWas(v) * t.total;
    return { now: now, was: was > now ? was : 0 };
  };

  // The 7-pair week set exists only on this page, only for "kasdien", and only once
  // its discount code is set in the section settings (the price is a claim the code must honour).
  const weekSet = () => !!(C.week && C.week.code && C.week.price > 0);
  const tiers = () => (weekSet() ? C.tiers.concat([{ total: 7, paid: 7, fixed: C.week.price, code: C.week.code, week: true }]) : C.tiers);
  const recommendedTier = () => {
    if (returning()) return 2;
    if (st.a.q8 === 'kasdien') return weekSet() ? 3 : 2;
    return ({ d12: 1, d34: 2, bandau: 0 })[st.a.q8] || 0;
  };
  const tierIndex = () => (st.tier >= 0 && st.tier < tiers().length ? st.tier : recommendedTier());

  // The same three lines for every result (owner's wording).
  const bullets = () => T.bullets.slice();

  // Gift choices as they travel with the order. Cart attributes outlive a
  // checkout link, so both are always sent and blanked when they do not apply
  // (a blank value removes the attribute); otherwise an earlier choice would
  // ride along on a later order.
  const giftFields = () => {
    const card = isGift() && st.a.q9 === 'kortele';
    return {
      attributes: { rask_pora: '1', Atvirukas: card ? 'Taip' : '', Siuntimas: isGift() && st.a.q9 === 'tiesiai' ? 'Tiesiai gavėjui' : '' },
      note: card ? 'Atvirukas. Palinkėjimas: ' + (st.msg || '(be teksto)') : '',
    };
  };

  const buyUrl = (v, t) => {
    let items = v.id + ':' + t.total;
    if (st.bag && C.bag) items += ',' + C.bag.id + ':1';
    const g = giftFields();
    const q = Object.keys(g.attributes).map((k) => 'attributes%5B' + encodeURIComponent(k) + '%5D=' + encodeURIComponent(g.attributes[k]));
    q.push('note=' + encodeURIComponent(g.note));
    if (t.code) q.push('discount=' + encodeURIComponent(t.code));
    return '/cart/' + items + '?' + q.join('&');
  };

  // The checkout link replaces the cart. Its contents are read once, so a
  // shopper who already holds other items can be told and offered to add instead.
  let cartItems = null;

  // Same request the product page sends for a sold-out colour: an event for
  // flows, and the address onto the product + colour list.
  const remind = (email, v, size) => {
    const P = product();
    let sent = false;
    try {
      const kl = window.klaviyo || window._learnq;
      if (kl && typeof kl.push === 'function') {
        kl.push(['identify', { $email: email }]);
        kl.push(['track', 'Back in Stock Request', { ProductName: P.title, ProductURL: location.origin + P.url, Colour: v.c, Size: size, VariantID: v.id, Source: 'Rask savo porą' }]);
        sent = true;
      }
    } catch (e) {}
    track('remind', { variant: v.id, size: size });
    const list = ((C.bis || {})[gender()] || {})[v.c];
    if (!list || !C.klaviyo) return Promise.resolve(sent);
    const body = { data: { type: 'subscription', attributes: { custom_source: 'Back in stock: ' + P.title + ' / ' + v.c + ' / ' + size, profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(C.klaviyo), { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body) })
      .then((res) => res.status === 202 || sent)
      .catch(() => sent);
  };

  /* ---------- drawings ---------- */

  const svg = (inner, cls) => '<svg class="rp-art' + (cls ? ' ' + cls : '') + '" viewBox="0 0 120 120" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + inner + '</svg>';

  const ART = {
    // Shoe sole, growing with the size.
    sole: (i) => {
      const k = 0.72 + i * 0.09;
      return svg('<g transform="translate(60 60) scale(' + k + ') translate(-60 -60)"><path d="M60 8c15 0 24 13 24 31 0 13-6 21-6 33 0 20-6 40-18 40s-18-16-18-36c0-13-6-24-6-37 0-18 9-31 24-31z"/><path d="M45 76h30M44 52h32" stroke-width="1.6" stroke-dasharray="3 5"/></g>');
    },
    // The same leg in four widths; the widest carries a sock mark.
    calf: (i) => {
      const w = [4, 10, 17, 24][i] || 10;
      const mark = i === 3 ? '<path d="M53 83q11 5 ' + (20 + w * 0.2) + ' 1" stroke-width="2" stroke-dasharray="2 5"/>' : '';
      return svg('<path d="M50 6c-2 30 1 60 3 84l1 9c0 6-12 6-22 8-7 2-7 9 1 9h40c5 0 5-6 3-11l-3-14c' + (w * 0.5) + '-20 ' + (8 + w) + '-50 ' + (4 + w * 0.5) + '-85"/>' + mark);
    },
    // A week with n days worn.
    // A week strip: day initials on top, a sock in every day the pair is worn.
    cal: (n) => {
      const DAYS = T.days || ['P', 'A', 'T', 'K', 'Pn', 'Š', 'S'];
      let out = '<rect x="4" y="22" width="152" height="76" rx="12" fill="#fff" stroke-width="1.6" opacity=".9"/>';
      for (let d = 0; d < 7; d++) {
        const x = 12 + d * 20.5;
        out += '<text x="' + (x + 8.5) + '" y="40" text-anchor="middle" font-family="Inter, system-ui, sans-serif" font-size="9.5" font-weight="700" fill="currentColor" stroke="none" opacity="' + (d < n ? '1' : '.5') + '">' + DAYS[d] + '</text>';
        if (d < n) {
          out += '<rect x="' + x + '" y="48" width="17" height="40" rx="5" fill="currentColor" stroke="none"/>';
          out += '<path d="M' + (x + 4) + ' 68.5l3.2 3.2 6-6.5" stroke="#fff" stroke-width="2.2" fill="none"/>';
        } else {
          out += '<rect x="' + x + '" y="48" width="17" height="40" rx="5" stroke-width="1.4" opacity=".35"/>';
        }
      }
      return '<svg class="rp-art rp-art--cal" viewBox="0 0 160 120" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + out + '</svg>';
    },
    ship: (i) => svg([
      '<path d="M24 44l36-16 36 16v36L60 96 24 80z"/><path d="M24 44l36 16 36-16M60 60v36"/>',
      '<rect x="20" y="34" width="80" height="54" rx="8"/><path d="M60 58c-5-9-18-6-18 3 0 8 10 13 18 19 8-6 18-11 18-19 0-9-13-12-18-3z"/>',
      '<path d="M60 104s28-26 28-48a28 28 0 0 0-56 0c0 22 28 48 28 48z"/><circle cx="60" cy="56" r="10"/>'
    ][i] || ''),
    any: () => {
      const P = product();
      const dots = colourOrder().map((c) => (P.variants.find((v) => v.c === c) || {}).hex || '#ccc');
      const n = dots.length;
      return '<span class="rp-dots">' + dots.map((hx, k) => '<i style="--sw:' + esc(hx) + ';--k:' + k + ';--n:' + n + '"></i>').join('') + '</span>';
    }
  };

  const artFor = (o) => {
    if (o.img) return '<img src="' + esc(C.img[o.img] || o.img) + '" alt="" width="640" height="800" decoding="async">';
    if (o.pimg) return '<img src="' + esc(o.pimg) + '" alt="" width="900" height="900" decoding="async">';
    if (o.art) { const p = o.art.split(':'); return (ART[p[0]] || (() => ''))(parseInt(p[1], 10) || 0); }
    return '';
  };

  /* ---------- questions ---------- */

  const optionsFor = (id) => {
    const q = Q[id];
    if (id === 'q0') return q.o.filter((o) => !(o.v === 'sau-w' && !sellable('w')) && !(o.v === 'sau-m' && !sellable('m')));
    if (id === 'qa') return q.o.map((o, i) => Object.assign({}, o, { pimg: (C.ages && C.ages[gender()] || [])[i] }));
    // Some cards carry a second photo for men.
    if (gender() === 'm' && q.o && q.o.some((o) => o.imgM)) return q.o.map((o) => (o.imgM ? Object.assign({}, o, { img: o.imgM }) : o));
    // The work-day photos follow the age answer (women): 30–39, 40–49 and 50+ have their own sets.
    if (id === 'q5') {
      const age = { '30-39': '30', '40-49': '40', '50': '50' }[st.a.qa] || '';
      return q.o.map((o) => (age && o.img && C.img[o.img + '-' + age] ? Object.assign({}, o, { img: o.img + '-' + age }) : o));
    }
    if (id === 'q2') return q[gender()].map((t, i) => ({ v: String(i), t: t, art: 'sole:' + i }));
    if (id === 'q7') {
      const P = product();
      const size = sizeFromAnswer();
      const live = colourOrder().filter((c) => { const v = findVariant(c, size); return v && v.ok; });
      const list = colourOrder().map((c) => {
        const v = findVariant(c, size) || P.variants.find((x) => x.c === c) || {};
        // Sold-out colours are only locked when something else can be picked.
        return { v: c, t: cName(c), pimg: heroImg(v), hex: v.hex, off: live.length > 0 && live.indexOf(c) < 0 };
      });
      if (gender() !== 'm') list.push({ v: 'any', t: q.any.t, s: q.any.s, art: 'any:0' });
      return list;
    }
    return q.o;
  };

  const layoutFor = (id, n) => {
    if (id === 'q7') return n > 4 ? 'grid3' : 'grid';
    return Q[id].layout || 'grid';
  };

  const preload = (id) => {
    if (!Q[id]) return;
    try { optionsFor(id).forEach((o) => { const src = o.img ? C.img[o.img] : o.pimg; if (src) { const im = new Image(); im.src = src; } }); } catch (e) {}
  };

  let lock = false;
  // Taps are ignored until a freshly shown question has settled, so a double tap cannot answer two questions.
  let readyAt = 0;

  const renderQuestion = (id, dir) => {
    const q = Q[id];
    const opts = optionsFor(id);
    const layout = layoutFor(id, opts.length);
    const sub = tx(q.sub);
    let html = '<div class="rp-screen' + (dir === 'back' ? ' rp-screen--back' : dir === 'none' ? ' rp-screen--still' : '') + '">';
    html += '<h1 class="rp-h">' + esc(tx(q.h)) + '</h1>';
    if (sub) html += '<p class="rp-sub">' + esc(sub) + '</p>';
    html += '<div class="rp-opts rp-opts--' + layout + '">';
    opts.forEach((o) => {
      const on = st.a[id] === o.v;
      const plain = !o.img && !o.pimg;
      html += '<button type="button" class="rp-opt' + (on ? ' is-on' : '') + (plain ? ' rp-opt--art' : '') + (o.off ? ' is-off' : '') + '" data-v="' + esc(o.v) + '"' + (o.off ? ' disabled' : '') + '>';
      if (o.flag) html += '<span class="rp-opt__flag">' + esc(o.flag) + '</span>';
      html += '<span class="rp-opt__img">' + artFor(o) + '</span>';
      html += '<span class="rp-opt__t">' + (o.hex ? '<i class="rp-dot" style="--sw:' + esc(o.hex) + '"></i>' : '') + '<span>' + esc(tx(o.t));
      if (o.off) html += '<small>' + esc(Q.q7.soldOut) + '</small>';
      else if (o.s) html += '<small>' + esc(tx(o.s)) + '</small>';
      html += '</span></span></button>';
    });
    html += '</div>';
    if (q.foot) html += '<p class="rp-foot">' + esc(tx(q.foot)) + '</p>';
    if (id === 'q9') {
      html += '<form class="rp-msg" data-rp-msg' + (st.a.q9 === 'kortele' ? '' : ' hidden') + '>';
      html += '<label for="rp-msg">' + esc(q.msgLabel) + '</label>';
      html += '<input id="rp-msg" type="text" maxlength="120" autocomplete="off" placeholder="' + esc(q.msgPh) + '">';
      html += '<button type="submit" class="rp-btn">' + esc(q.msgNext) + '</button></form>';
    }
    html += '</div>';
    stage.innerHTML = html;

    const msg = stage.querySelector('[data-rp-msg]');
    if (msg) {
      msg.querySelector('input').value = st.msg || '';
      msg.addEventListener('submit', (ev) => {
        ev.preventDefault();
        st.msg = msg.querySelector('input').value.trim().slice(0, 120);
        go(id);
      });
    }

    stage.querySelectorAll('.rp-opt').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (lock || btn.disabled || Date.now() < readyAt) return;
        const v = btn.dataset.v;
        stage.querySelectorAll('.rp-opt').forEach((b) => b.classList.toggle('is-on', b === btn));
        commit(id, v);
        // The card message is the one place where a tap does not move on.
        if (id === 'q9' && v === 'kortele' && msg) {
          msg.hidden = false;
          save();
          msg.querySelector('input').focus();
          return;
        }
        if (msg) msg.hidden = true;
        lock = true;
        setTimeout(() => { lock = false; go(id); }, 200);
      });
    });

    if (dir !== 'none') {
      readyAt = Date.now() + 400;
      // Keyboard and screen-reader users land on the new question, not back at the top of the page.
      const head = stage.querySelector('.rp-h');
      if (head) { head.tabIndex = -1; head.focus({ preventScroll: true }); }
    }

    const p = path();
    preload(p[p.indexOf(id) + 1]);
  };

  // Store an answer and drop whatever was derived from the old one.
  const commit = (id, v) => {
    const changed = st.a[id] !== v;
    st.a[id] = v;
    // Answering a question again, even with the same answer, puts its result-page override back to the answer.
    if (id === 'q2') st.size = '';
    if (id === 'q7') st.colour = '';
    if (id === 'q8') st.tier = -1;
    if (changed) {
      if (id === 'q0' || id === 'q1') { st.colour = ''; st.size = ''; }
      if (id === 'q4') st.tier = -1;
      if (id === 'q9' && v !== 'kortele') st.msg = '';
    }
    track('step', { step: id, answer: v });
  };

  const go = (from) => {
    st.hist.push(from);
    show(nextOf(from), 'fwd');
  };

  /* ---------- loader ---------- */

  let loaderTimer = 0;
  const renderLoader = () => {
    stage.innerHTML = '<div class="rp-screen rp-loader"><span class="rp-spin" aria-hidden="true"></span><p class="rp-h">' + esc(tx(T.loader)) + '</p></div>';
    clearTimeout(loaderTimer);
    loaderTimer = setTimeout(() => {
      if (st.cur !== 'result') return;
      st.done = true;
      st.secs = Math.round((Date.now() - st.t0) / 1000);
      save();
      renderResult(true);
    }, 1500);
  };

  /* ---------- result ---------- */

  const STAR = '<svg viewBox="0 0 24 24" width="13" height="13" focusable="false"><path fill="#E8B44A" d="M12 2.2l2.9 6.7 7.2.6-5.5 4.7 1.7 7-6.3-3.8-6.3 3.8 1.7-7L1.9 9.5l7.2-.6z"/></svg>';
  const STAR_W = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.6l2.7 6.8 7.3.6-5.6 4.6 1.8 7.1L12 17.8 5.8 21.7l1.8-7.1L2 10l7.3-.6z"/></svg>';
  // The product page's sock drawing, one per pair, up to five
  const sockArt = (n) => {
    const k = Math.min(n, 5);
    let g = '';
    for (let i = 0; i < k; i++) g += '<g transform="translate(' + (i * 7) + ' ' + ((i % 2) * 2) + ')"><path d="M7 2H23V35C23 38.6 24.4 40.6 27.5 42L30 43.1C33.4 44.6 33.8 50.6 30.5 52.7C29.6 53.3 28.6 53.5 27.5 53.5H11C7.7 53.5 5.5 51.2 5.5 47.9V43.8C5.5 42.1 7 40.6 7 38.6Z" fill="#f6f4f5" stroke="#aca6a9" stroke-width="1.15" stroke-linejoin="round"/><path d="M7 8H23M5.7 46.6C8.7 46.3 10.9 48.6 11.1 53.5M26.7 53.4C26.1 50 27.2 46.3 30.4 44" fill="none" stroke="#c8c2c5" stroke-width="1"/></g>';
    return '<svg viewBox="0 0 ' + ((k - 1) * 7 + 35) + ' 60">' + g + '</svg>';
  };
  const TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  const renderResult = (first) => {
    const P = product();
    const r = pick();
    const v = r.v;
    const ti = tierIndex();
    const tier = tiers()[ti];
    const price = tierPrice(v, tier);
    const total = price.now + (st.bag && C.bag ? C.bag.price : 0);
    const rec = recommendedTier();
    const gift = isGift();

    let h = '<div class="rp-res' + (first ? ' rp-screen' : '') + '">';
    h += '<div class="rp-res__left"><div class="rp-res__media"><img src="' + esc(heroImg(v)) + '" alt="' + esc(P.title + ', ' + cName(v.c)) + '" width="900" height="900">';
    // Nothing was found when the size is gone in every colour, so the page does not say so.
    h += '</div>';
    const pics = gallery(v);
    if (pics.length > 1) {
      h += '<div class="rp-gallery" role="group" aria-label="' + esc(P.title) + '">';
      pics.forEach((src, k) => { h += '<button type="button" class="rp-thumb' + (k === 0 ? ' is-on' : '') + '" data-pic="' + esc(src) + '" aria-pressed="' + (k === 0) + '"><img src="' + esc(src) + '" alt="" width="160" height="160" loading="lazy"></button>'; });
      h += '</div>';
    }
    h += '</div>';
    h += '<div class="rp-res__body">';
    h += '<p class="rp-kicker">' + esc(r.out ? (isNewSize(r.size) ? T.soon : T.outKicker) : tx(T.kicker)) + '</p>';
    if (!r.out && C.rating) h += '<p class="rp-res__found"><span class="rp-stars" aria-hidden="true">' + STAR + STAR + STAR + STAR + STAR + '</span><span>' + esc(C.rating) + '</span></p>';
    h += '<h1 class="rp-res__title">' + esc(P.title) + '</h1>';
    const ICO_SIZE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.5" y="8" width="19" height="8" rx="2"/><path d="M6.5 8v3M10 8v4.5M13.5 8v3M17 8v4.5"/></svg>';
    const ICO_RESTART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1"/><path d="M3.5 4v5h5"/></svg>';
    // What was chosen, each with its own "change" control
    h += '<div class="rp-sel">';
    h += '<button type="button" class="rp-sel__card" data-rp-toggle="colour" aria-expanded="false"><i class="rp-dot rp-dot--big" style="--sw:' + esc(v.hex) + '"></i><span class="rp-sel__t"><small>' + esc(T.colourLabel) + '</small><b>' + esc(cName(v.c)) + '</b></span><span class="rp-sel__go">' + esc(T.change) + '</span></button>';
    h += '<button type="button" class="rp-sel__card" data-rp-toggle="size" aria-expanded="false"><span class="rp-sel__ico">' + ICO_SIZE + '</span><span class="rp-sel__t"><small>' + esc(T.sizeLabel) + '</small><b>' + esc(sizeLabel(v.s)) + '</b></span><span class="rp-sel__go">' + esc(T.change) + '</span></button>';
    h += '</div>';
    h += '<div class="rp-picker" data-rp-picker="colour" hidden>';
    colourOrder().forEach((c) => {
      const cv = findVariant(c, r.size);
      const ok = !!(cv && cv.ok);
      h += '<button type="button" class="rp-chip' + (c === v.c ? ' is-on' : '') + '" data-colour="' + esc(c) + '"' + (ok ? '' : ' disabled') + '><i class="rp-dot" style="--sw:' + esc((cv || {}).hex || '#ccc') + '"></i>' + esc(cName(c)) + (ok ? '' : ' <small>' + esc(T.soldOut) + '</small>') + '</button>';
    });
    h += '</div><div class="rp-picker" data-rp-picker="size" hidden>';
    P.sizes.forEach((s) => {
      const ok = P.variants.some((x) => x.s === s && x.ok);
      const soon = !ok && isNewSize(s);
      // An old size with nothing left is gone, not offered; a new one waits for stock.
      if (!ok && !soon) return;
      h += '<button type="button" class="rp-chip' + (s === r.size ? ' is-on' : '') + '" data-size="' + esc(s) + '"' + (soon ? ' disabled' : '') + '>' + esc(sizeLabel(s)) + (ok ? '' : ' <small>' + esc(T.soon) + '</small>') + '</button>';
    });
    h += '<a class="rp-sizelink" href="' + esc(P.url) + '#dydziu-lentele">' + esc(T.sizeTable || 'Dydžių lentelė') + '</a>';
    h += '</div>';
    if (r.note) h += '<p class="rp-note">' + esc(r.note) + '</p>';

    h += '<section class="rp-why"><h2 class="rp-res__h">' + esc(T.why) + '</h2><ul>';
    bullets().forEach((b) => { h += '<li><i>' + TICK + '</i><span>' + esc(b) + '</span></li>'; });
    h += '</ul></section>';

    if (r.out) {
      h += '<p class="rp-note rp-note--out">' + esc((isNewSize(r.size) && T.sizeSoon ? T.sizeSoon : T.sizeOut).replace('{size}', () => sizeLabel(r.size))) + '</p>';
      h += '<form class="rp-email rp-bis" data-rp-bis><p>' + esc(isNewSize(r.size) && T.bisTitleSoon ? T.bisTitleSoon : T.bisTitle) + '</p><div><input type="email" required autocomplete="email" placeholder="' + esc(T.emailPh) + '" aria-label="' + esc(T.emailPh) + '"><button type="submit" class="rp-btn">' + esc(T.bisBtn) + '</button></div><p class="rp-bis__consent">' + esc(T.bisConsent) + '</p><p class="rp-email__msg" data-rp-bis-msg hidden></p></form>';
    } else {
      h += '<h2 class="rp-res__h">' + esc(T.qty) + '</h2>';
      const TIERS = tiers();
      h += '<div class="rp-tiers' + (TIERS.length > 3 ? ' rp-tiers--4' : '') + '" role="group" aria-label="' + esc(T.qty) + '">';
      TIERS.forEach((t, k) => {
        const pr = tierPrice(v, t);
        const free = t.total - t.paid;
        h += '<button type="button" aria-pressed="' + (k === ti) + '" class="rp-tier' + (k === ti ? ' is-on' : '') + (t.week ? ' rp-tier--week' : '') + '" data-tier="' + k + '">';
        const flag = T.flags && T.flags[t.week ? 3 : k];
        if (flag) h += '<span class="rp-tier__flag">' + STAR_W + esc(flag) + '</span>';
        h += '<b>' + esc(t.week ? pairs(t.total) : pairs(t.paid)) + '</b>';
        h += '<small>' + (t.week ? esc(T.weekSet) : free > 0 ? '+' + esc(free + ' ' + T.free) : '&nbsp;') + '</small>';
        h += '<span class="rp-tier__art" aria-hidden="true">' + sockArt(t.total) + '</span>';
        h += '<span class="rp-tier__now">' + esc(money(pr.now)) + '</span>';
        h += '<s>' + (pr.was ? esc(money(pr.was)) : '&nbsp;') + '</s>';
        if (C.freeShipAt > 0 && pr.now >= C.freeShipAt) h += '<em>' + esc(T.freeShip) + '</em>';
        h += '<span class="rp-tier__tick" aria-hidden="true">' + TICK + '</span>';
        h += '</button>';
      });
      h += '</div>';
      const rt = TIERS[rec];
      h += '<p class="rp-recline">' + esc(T.recLine) + ': ' + esc(rt.week ? pairs(rt.total) : pairs(rt.paid) + (rt.total > rt.paid ? ' + ' + (rt.total - rt.paid) + ' ' + T.free : '')) + '</p>';
      if (st.a.q8 === 'bandau' && ti === 0 && C.tiers[1]) {
        const per = Math.round(tierPrice(v, C.tiers[1]).now / C.tiers[1].total);
        h += '<p class="rp-nudge">' + esc(T.perPair.replace('{per}', () => money(per)).replace('{unit}', () => money(unitNow(v)))) + '</p>';
      }
      if (C.bag) {
        // The bag can be what lifts the order over the free delivery line; say so when it does.
        const lifts = C.freeShipAt > 0 && price.now < C.freeShipAt && price.now + C.bag.price >= C.freeShipAt;
        h += '<label class="rp-addon"><input type="checkbox" data-rp-bag' + (st.bag ? ' checked' : '') + '><span class="rp-addon__box">' + TICK + '</span><span>+ ' + esc(T.bag) + (lifts ? '<small>' + esc(T.bagShip) + '</small>' : '') + '</span><b>' + esc(money(C.bag.price)) + '</b></label>';
      }
      if (gift && st.a.q9 === 'kortele') h += '<p class="rp-note">' + esc(T.giftCard) + '</p>';
      if (gift && st.a.q9 === 'tiesiai') h += '<p class="rp-note">' + esc(T.giftDirect) + '</p>';
      h += '<div class="rp-cartnote" data-rp-cartnote hidden><p>' + esc(T.cartNote) + '</p><button type="button" data-rp-add>' + esc(T.cartAdd) + '</button><p class="rp-cartnote__err" data-rp-add-err hidden>' + esc(T.cartErr) + '</p></div>';
      h += '<div class="rp-buy"><a class="rp-cta" href="' + esc(buyUrl(v, tier)) + '" data-rp-buy><span>' + esc(T.cta) + '</span><span class="rp-cta__sum">' + esc(money(total)) + '</span></a></div>';
      const TRUST_ICONS = [
        '<circle cx="16" cy="31" r="9" fill="#F2C4D0"/><path d="M24 5l15 5.5v11c0 9.5-6.4 16.4-15 19.5C15.4 37.9 9 31 9 21.5v-11z" stroke="#101820" stroke-width="2.4" stroke-linejoin="round"/><path d="M17 22.5l5 5 9-10" stroke="#101820" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>',
        '<circle cx="18" cy="9" r="6.5" fill="#F2C4D0"/><g stroke="#101820" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"><path d="M24 12.5c-1.4-2.8-5.8-2.4-5.8.7 0 2.6 3.6 4.6 5.8 6.3 2.2-1.7 5.8-3.7 5.8-6.3 0-3.1-4.4-3.5-5.8-.7z"/><path d="M9 25v13l15 5 15-5V25"/><path d="M9 25l15 5 15-5"/><path d="M24 30v13"/><path d="M9 25l-4.5-5.5 15-4.5 4.5 5"/><path d="M39 25l4.5-5.5-15-4.5-4.5 5"/></g>',
        '<path d="M11 4l1.5 3.8L16.3 9.3l-3.8 1.5L11 14.6l-1.5-3.8L5.7 9.3l3.8-1.5z" fill="#F2C4D0"/><path d="M20.5 2.5l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z" fill="#F2C4D0"/><g stroke="#101820" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"><path d="M16 16h17v17H16z"/><path d="M33 21.5h6l5 6V33H33"/><circle cx="21.5" cy="35" r="3"/><circle cx="38.5" cy="35" r="3"/><path d="M4 20h8"/><path d="M2 25h10"/><path d="M6 30h6"/></g>'
      ];
      h += '<ul class="rp-trust">' + T.trust.map((x, k) => '<li><svg viewBox="0 0 48 48" fill="none" aria-hidden="true">' + (TRUST_ICONS[k] || TRUST_ICONS[0]) + '</svg><span>' + esc(x) + '</span></li>').join('') + '</ul>';
    }

    if (GIFT_MODE && T.giftSet) h += '<p class="rp-giftlink"><a class="rp-btn rp-btn--gift" href="' + (gender() === 'm' ? '/products/bambukines-placios-kompresines-kojines-vyrams?view=dovanos-vyrams' : '/products/bambuko-kompresines-kojines?view=dovanos') + '">' + esc(T.giftSet) + ' →</a></p>';
    h += '<button type="button" class="rp-restart" data-rp-restart>' + ICO_RESTART + '<span>' + esc(T.restart) + '</span></button>';

    if (C.emailOn) {
      h += '<form class="rp-email" data-rp-email><p>' + esc(T.emailTitle) + '</p><div><input type="email" required autocomplete="email" placeholder="' + esc(T.emailPh) + '" aria-label="' + esc(T.emailPh) + '"><button type="submit" class="rp-btn">' + esc(T.emailBtn) + '</button></div><p class="rp-email__msg" data-rp-email-msg hidden></p></form>';
    }
    h += '</div></div>';

    const y = window.scrollY;
    // A redraw must not drop keyboard focus: note which control had it and hand it to its replacement.
    const act = document.activeElement;
    let refocus = '';
    if (!first && act && stage.contains(act)) {
      const d = act.dataset;
      refocus = d.tier !== undefined ? '[data-tier="' + d.tier + '"]' : d.colour !== undefined ? '[data-rp-toggle="colour"]' : d.size !== undefined ? '[data-rp-toggle="size"]' : d.rpBag !== undefined ? '[data-rp-bag]' : '';
    }
    stage.innerHTML = h;
    if (!first) window.scrollTo(0, y);
    const again1 = refocus && stage.querySelector(refocus);
    if (again1) again1.focus({ preventScroll: true });
    else if (first) { const title = stage.querySelector('.rp-res__title'); if (title) { title.tabIndex = -1; title.focus({ preventScroll: true }); } }

    const again = () => { save(); renderResult(false); };

    stage.querySelectorAll('[data-tier]').forEach((b) => b.addEventListener('click', () => { st.tier = parseInt(b.dataset.tier, 10); again(); }));
    // Thumbnails swap the big photo in place; nothing else is redrawn.
    const hero = stage.querySelector('.rp-res__media img');
    stage.querySelectorAll('[data-pic]').forEach((b) => b.addEventListener('click', () => {
      hero.src = b.dataset.pic;
      stage.querySelectorAll('[data-pic]').forEach((o) => { o.classList.toggle('is-on', o === b); o.setAttribute('aria-pressed', String(o === b)); });
    }));
    const bag = stage.querySelector('[data-rp-bag]');
    if (bag) bag.addEventListener('change', () => { st.bag = bag.checked; again(); });

    stage.querySelectorAll('[data-rp-toggle]').forEach((b) => b.addEventListener('click', () => {
      const which = b.dataset.rpToggle;
      stage.querySelectorAll('[data-rp-picker]').forEach((p) => {
        const mine = p.dataset.rpPicker === which;
        p.hidden = mine ? !p.hidden : true;
      });
      stage.querySelectorAll('[data-rp-toggle]').forEach((t) => {
        const p = stage.querySelector('[data-rp-picker="' + t.dataset.rpToggle + '"]');
        t.setAttribute('aria-expanded', String(!p.hidden));
      });
    }));
    stage.querySelectorAll('[data-colour]').forEach((b) => b.addEventListener('click', () => { st.colour = b.dataset.colour; again(); }));
    stage.querySelectorAll('[data-size]').forEach((b) => b.addEventListener('click', () => { st.size = b.dataset.size; again(); }));

    stage.querySelector('[data-rp-restart]').addEventListener('click', restart);

    const buy = stage.querySelector('[data-rp-buy]');
    if (buy) buy.addEventListener('click', () => {
      const data = { variant: v.id, tier: tier.total, value: total / 100, currency: C.currency };
      track('buy', data);
      pixel('RaskPoraBuy', { content_ids: [String(v.id)], content_type: 'product', num_items: tier.total, value: total / 100, currency: C.currency });
    });

    const cartNote = stage.querySelector('[data-rp-cartnote]');
    if (cartNote) {
      // Items that this very result put there (after a visit to checkout and back) are not "other items".
      const reveal = (items) => {
        const mine = (i) => i.variant_id === v.id || (C.bag && i.variant_id === C.bag.id);
        if (items.length && !items.every(mine) && cartNote.isConnected) cartNote.hidden = false;
      };
      if (cartItems) reveal(cartItems);
      else fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json()).then((c) => { cartItems = c.items || []; reveal(cartItems); }).catch(() => {});

      const addBtn = cartNote.querySelector('[data-rp-add]');
      addBtn.addEventListener('click', () => {
        const items = [v.pre && C.presale ? { id: v.id, quantity: tier.total, properties: { [C.presaleKey || '_Išankstinis užsakymas']: C.presale } } : { id: v.id, quantity: tier.total }];
        // a set (3+ pairs) is marked on its line (hidden): the cart shows no free-pair box next to it
        if (tier.total >= 3) items[0].properties = Object.assign({}, items[0].properties || {}, { _bundle: String(tier.total) });
        if (st.bag && C.bag) items.push({ id: C.bag.id, quantity: 1 });
        const g = giftFields();
        const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then((res) => { if (!res.ok) throw new Error(String(res.status)); return res; });
        addBtn.disabled = true;
        const upd = g.note ? { attributes: g.attributes, note: g.note } : { attributes: g.attributes };
        if (tier.code) upd.discount = tier.code;
        post('/cart/add.js', { items: items })
          .then(() => post('/cart/update.js', upd))
          .then(() => { track('add', { variant: v.id, tier: tier.total }); location.href = '/cart'; })
          .catch(() => { addBtn.disabled = false; cartNote.querySelector('[data-rp-add-err]').hidden = false; });
      });
    }

    const bis = stage.querySelector('[data-rp-bis]');
    if (bis) bis.addEventListener('submit', (ev) => {
      ev.preventDefault();
      const email = bis.querySelector('input').value.trim();
      const out = bis.querySelector('[data-rp-bis-msg]');
      const btn = bis.querySelector('button');
      if (!email) return;
      btn.disabled = true;
      remind(email, v, r.size).then((ok) => {
        out.textContent = ok ? T.bisOk : T.bisErr;
        out.hidden = false;
        btn.disabled = false;
        if (ok) { bis.querySelector('div').hidden = true; bis.querySelector('.rp-bis__consent').hidden = true; }
      });
    });

    const mail = stage.querySelector('[data-rp-email]');
    if (mail) mail.addEventListener('submit', (ev) => {
      ev.preventDefault();
      const email = mail.querySelector('input').value.trim();
      const out = mail.querySelector('[data-rp-email-msg]');
      if (!email) return;
      sendResult(email, v, tier).then((ok) => {
        out.textContent = ok ? T.emailDone : T.emailErr;
        out.hidden = false;
        if (ok) mail.querySelector('div').hidden = true;
      });
    });

    if (first) {
      window.scrollTo(0, 0);
      track('result', { variant: v.id, tier: tier.total, colour: v.c, size: v.s });
      pixel('RaskPoraResult', { content_ids: [String(v.id)], content_type: 'product', content_name: P.title, value: price.now / 100, currency: C.currency });
    }
  };

  // Only runs when the shopper types an address on the result (section setting).
  const sendResult = (email, v, tier) => {
    if (!C.klaviyo) return Promise.resolve(false);
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); else (window._learnq = window._learnq || []).push(['identify', { $email: email }]); } catch (e) {}
    const props = Object.assign({}, st.a, { product: product().title, colour: v.c, size: v.s, pairs: tier.total, variant_id: v.id, checkout_url: location.origin + buyUrl(v, tier), gift: isGift() });
    const body = { data: { type: 'event', attributes: { properties: props, metric: { data: { type: 'metric', attributes: { name: 'Rask pora completed' } } }, profile: { data: { type: 'profile', attributes: { email: email } } } } } };
    return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(C.klaviyo), { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body) })
      .then((res) => { if (res.ok) track('email', {}); return res.ok; })
      .catch(() => false);
  };

  const restart = () => {
    clearTimeout(loaderTimer);
    st = fresh();
    save();
    track('start', {});
    show('q0', 'none');
    window.scrollTo(0, 0);
  };
  root.querySelector('[data-rp-restart-top]').addEventListener('click', restart);

  /* ---------- navigation ---------- */

  // Gift mode ends by handing the pick to the gift page, which sets every pair to it.
  const giftGo = () => {
    const r = pick();
    const colour = (r.v && r.v.c) || st.colour || '';
    const base = gender() === 'm' ? '/products/bambukines-placios-kompresines-kojines-vyrams?view=dovanos-vyrams' : '/products/bambuko-kompresines-kojines?view=dovanos';
    try { localStorage.removeItem(KEY); } catch (e) {}
    // PL: the gift page compares Polish option values (Stopa 37–39, Czarny)
    const qSize = T.footWord ? String(r.size || '').replace(/^Pėda /, T.footWord + ' ') : (r.size || '');
    window.location.href = base + '&qsize=' + encodeURIComponent(qSize) + '&qcolour=' + encodeURIComponent(cName(colour)) + '#gl-pirkti';
  };
  const show = (id, dir) => {
    if (id === 'giftgo') { giftGo(); return; }
    st.cur = id;
    save();
    const p = path();
    const i = p.indexOf(id);
    const atResult = id === 'result';
    barEl.style.width = (atResult ? 100 : Math.round(((i < 0 ? 0 : i) / p.length) * 100)) + '%';
    countEl.textContent = atResult || i < 0 ? '' : (i + 1) + ' / ' + p.length;
    root.classList.toggle('rp--result', atResult);
    if (atResult) {
      // A saved result is redrawn quietly; only a fresh one animates and is tracked.
      if (st.done) renderResult(false);
      else renderLoader();
      return;
    }
    renderQuestion(id, dir);
    if (dir !== 'none') window.scrollTo(0, 0);
  };

  // The cookie bar is fixed to the bottom of the screen until it is answered. The quiz leaves room for
  // it (--rp-cb in the stylesheet), so the last answers and the buy button never end up underneath.
  let barSeen = null;
  const clearBar = () => {
    const b = document.getElementById('shopify-pc__banner');
    if (b && b !== barSeen && window.ResizeObserver) { barSeen = b; new ResizeObserver(clearBar).observe(b); }
    const cs = b && b.isConnected ? getComputedStyle(b) : null;
    const shown = !!cs && cs.display !== 'none' && cs.visibility !== 'hidden';
    root.style.setProperty('--rp-cb', (shown ? Math.round(b.getBoundingClientRect().height) : 0) + 'px');
  };
  clearBar();
  try {
    new MutationObserver(clearBar).observe(document.body, { childList: true });
    window.addEventListener('resize', clearBar, { passive: true });
  } catch (e) {}

  backBtn.addEventListener('click', () => {
    if (lock) return;
    if (!st.hist.length) {
      // First question: back means leaving the quiz.
      let same = false;
      try { same = !!document.referrer && new URL(document.referrer).origin === location.origin; } catch (e) {}
      if (same && history.length > 1) history.back();
      else location.href = (product() || {}).url || C.home || '/';
      return;
    }
    clearTimeout(loaderTimer);
    st.done = false;
    show(st.hist.pop(), 'back');
  });

  // Neither product can be sold (both unpublished): nothing to ask, send the shopper back to the shop.
  if (!GENDERS.length) { location.replace(C.home || '/'); return; }

  const saved = load();
  if (saved) st = saved;
  try { show(st.cur, 'none'); } catch (e) { st = fresh(); show('q0', 'none'); }
  if (!saved) track('start', {});
})();
